type LangType = {
    channelFeeds: string
    previewTitle: string
    previewAll: string
    visibilityAll: string
    visibilitySubs: string
    emptyMessage: string
    visibility: string
    subsVisibility: string
    subsProductLabel: string
    image: string
    imageDescription: string
    title: string
    titleHint: string
    sentence: string
    sentenceHint: string
    url: string
    urlHint: string
    errorEmpty: string
    postTitle: string
    postDescription: string
    cancel: string
    post: string
    noticePost: string
    noticeUpdate: string
    noticeRemove: string
    noticeSortToTop: string
    edit: string
    sortToTop: string
    remove: string
    updateTitle: string
    update: string
    removeTitle: string
    removeDescription: string
    errorUnknown: string
    errorInvalidUrl: string
    memberOnly: string
    subsDescription: string
    ok: string
    subsReload: string
    noticeMemberOnly: string
    noticeSubsProducts: string
}

const ja: LangType = {
    channelFeeds: 'チャンネルフィード',
    previewTitle: 'ユーザーを選択してプレビュー',
    previewAll: '非サブスクメンバー',
    visibilityAll: '全体公開',
    visibilitySubs: 'サブスクメンバー限定',
    emptyMessage: '投稿がありません',
    visibility: '公開範囲',
    subsVisibility: 'サブスクメンバー公開範囲',
    subsProductLabel: 'プラン{index}「{name}」以上',
    image: '画像',
    imageDescription: '画像は320pxで表示されます。',
    title: 'タイトル',
    titleHint: 'タイトルを入力',
    sentence: '文章',
    sentenceHint: '文章を入力',
    url: 'URL',
    urlHint: '文章を入力',
    errorEmpty: 'データが入力されていません。',
    postDescription: '投稿するには、画像・タイトル・文章の中どれか1つの入力が必要です。',
    cancel: 'キャンセル',
    postTitle: '投稿を作成',
    post: '投稿',
    noticePost: 'チャンネルフィードを投稿しました。',
    noticeUpdate: '更新しました。',
    noticeRemove: '削除しました。',
    noticeSortToTop: '表示順を一番上にしました。',
    edit: '編集',
    sortToTop: '一番上に表示',
    remove: '削除',
    updateTitle: '投稿を編集',
    update: '更新',
    removeTitle: '投稿を削除しますか？',
    removeDescription: '投稿を削除すると、元に戻すことはできません。',
    errorUnknown: 'エラーが発生しました',
    errorInvalidUrl: 'URLが正しくありません',
    memberOnly: 'メンバー限定',
    subsDescription: 'サブスクに入会するとこのコンテンツを表示することができます。サブスク情報ページに進みますか？',
    ok: 'OK',
    subsReload: '限定コンテンツを読み込む',
    noticeMemberOnly: 'サブスクメンバーのみが表示できます',
    noticeSubsProducts: 'このコンテンツを表示できるサブスクプラン'
}

export const Lang = {
    ja
}
